module.exports = __webpack_public_path__ + "img/competition_benefit4.1a3de484.png";